
import { BasePage } from "./BasePage";

import type { PageTemplateProps } from "./types";

// Specialty page — used for Private Label & White Label or any other
// specialty content the prospect needs (per Digital Data Room spec).
// Layout-wise nothing custom; SEM populates widgets in JSON.
export function Specialty(props: PageTemplateProps) {
    return <BasePage {...props} />;
}
